import styled from 'styled-components';

export const AboutSvgStyled = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media(max-width: 991px), (max-height: 540px) {
        height: 100%;
    }

    #e9okq2uzh7l62_to {
        animation: e9okq2uzh7l62_to__to 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l62_to__to {
        0% {
            transform: translate(435.938803px, 119.723850px)
        }

        36.666667% {
            transform: translate(435.938803px, 119.723850px)
        }

        53.333333% {
            transform: translate(435.922000px, 118.405000px)
        }

        100% {
            transform: translate(435.922000px, 118.405000px)
        }
    }

    #e9okq2uzh7l62_tr {
        animation: e9okq2uzh7l62_tr__tr 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l62_tr__tr {
        0% {
            transform: rotate(0deg)
        }

        36.666667% {
            transform: rotate(0deg)
        }

        53.333333% {
            transform: rotate(10deg)
        }

        66.666667% {
            transform: rotate(0deg)
        }

        100% {
            transform: rotate(0deg)
        }
    }

    #e9okq2uzh7l66_to {
        animation: e9okq2uzh7l66_to__to 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l66_to__to {
        0% {
            transform: translate(447.227442px, 57.006900px)
        }

        36.666667% {
            transform: translate(447.227442px, 57.006900px)
        }

        53.333333% {
            transform: translate(458.009923px, 60.807525px)
        }

        66.666667% {
            transform: translate(447.227442px, 57.006900px)
        }

        100% {
            transform: translate(447.227442px, 57.006900px)
        }
    }

    #e9okq2uzh7l66_tr {
        animation: e9okq2uzh7l66_tr__tr 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l66_tr__tr {
        0% {
            transform: rotate(0deg)
        }

        36.666667% {
            transform: rotate(0deg)
        }

        53.333333% {
            transform: rotate(10deg)
        }

        66.666667% {
            transform: rotate(0deg)
        }

        100% {
            transform: rotate(0deg)
        }
    }

    #e9okq2uzh7l67_to {
        animation: e9okq2uzh7l67_to__to 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l67_to__to {
        0% {
            transform: translate(589.255264px, 462.289794px)
        }

        10% {
            transform: translate(601.492944px, 463.792855px)
        }

        20% {
            transform: translate(589.492944px, 460.792855px)
        }

        33.333333% {
            transform: translate(601.492944px, 463.792855px)
        }

        43.333333% {
            transform: translate(589.492944px, 460.792855px)
        }

        100% {
            transform: translate(589.492944px, 460.792855px)
        }
    }

    #e9okq2uzh7l67_tr {
        animation: e9okq2uzh7l67_tr__tr 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l67_tr__tr {
        0% {
            transform: rotate(0deg)
        }

        10% {
            transform: rotate(-3deg)
        }

        20% {
            transform: rotate(0deg)
        }

        33.333333% {
            transform: rotate(-3deg)
        }

        43.333333% {
            transform: rotate(0deg)
        }

        100% {
            transform: rotate(0deg)
        }
    }

    #e9okq2uzh7l69_to {
        animation: e9okq2uzh7l69_to__to 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l69_to__to {
        0% {
            transform: translate(267.673006px, 448.853617px)
        }

        6.666667% {
            transform: translate(267.673006px, 448.853617px)
        }

        16.666667% {
            transform: translate(255.673006px, 445.853617px)
        }

        26.666667% {
            transform: translate(265.673006px, 449.853617px)
        }

        36.666667% {
            transform: translate(265.403505px, 449.853617px)
        }

        46.666667% {
            transform: translate(265.673006px, 449.853617px)
        }

        100% {
            transform: translate(265.673006px, 449.853617px)
        }
    }

    #e9okq2uzh7l69_tr {
        animation: e9okq2uzh7l69_tr__tr 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l69_tr__tr {
        0% {
            transform: rotate(0deg)
        }

        6.666667% {
            transform: rotate(0deg)
        }

        16.666667% {
            transform: rotate(5deg)
        }

        26.666667% {
            transform: rotate(0deg)
        }

        36.666667% {
            transform: rotate(0deg)
        }

        46.666667% {
            transform: rotate(0deg)
        }

        100% {
            transform: rotate(0deg)
        }
    }

    #e9okq2uzh7l633_to {
        animation: e9okq2uzh7l633_to__to 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l633_to__to {
        0% {
            transform: translate(115.017130px, 138.224658px)
        }

        23.333333% {
            transform: translate(113.989530px, 143.560539px)
        }

        50% {
            transform: translate(107.803155px, 141.683332px)
        }

        73.333333% {
            transform: translate(109.680248px, 136.347035px)
        }

        100% {
            transform: translate(115.015925px, 138.224294px)
        }
    }

    #e9okq2uzh7l633_tr {
        animation: e9okq2uzh7l633_tr__tr 3000ms linear infinite normal forwards
    }

    @keyframes e9okq2uzh7l633_tr__tr {
        0% {
            transform: rotate(180deg)
        }

        100% {
            transform: rotate(540deg)
        }
    }
`